export enum DaytimeEnum {
    BEFOREBREAKFAST = 'beforebreakfast',
    DURINGBREAKFAST = 'duringbreakfast',
    AFTERBREAKFAST = 'afterbreakfast',
    MORNING = 'morning',
    BETWEENBREAKFASTANDLUNCH = 'betweenbreakfastandlunch',
    BEFORELUNCH = 'beforelunch',
    DURINGLUNCH = 'duringlunch',
    AFTERLUNCH = 'afterlunch',
    AFTERNOON = 'afternoon',
    BETWEENLUNCHANDDINNER = 'betweenlunchanddinner',
    BEFOREDINNER = 'beforedinner',
    DURINGDINNER = 'duringdinner',
    AFTERDINNER = 'afterdinner',
    EVENING = 'evening',
    THEHOUROFSLEEP = 'thehourofsleep',
    NIGHT = 'night',

    AFTERMEAL = 'aftermeal',
    BETWEENDINNERANDSLEEP = 'betweendinnerandsleep',
    BETWEENMEALS = 'betweenmeals',
}
